import { useEffect } from "react";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";

export function PWAUpdateNotifier() {
  useEffect(() => {
    const handler = () => {
      toast("Updating to the latest version…", {
        description: "The page will refresh automatically.",
        duration: 4000,
        icon: <RefreshCw className="h-4 w-4 animate-spin" />,
      });
    };

    window.addEventListener("pwa-update-available", handler);
    return () => window.removeEventListener("pwa-update-available", handler);
  }, []);

  return null;
}
